import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import cookie from 'react-cookies';
import { ValidateState } from '../../../functions';
import { API_URL } from '../../../constants';
import { updateValueInJson, validateAccesoGeneral, getRoles, esUrl } from '../../../functions';
import axios from 'axios';
import $ from 'jquery';
import { DropDownList } from '../../Elements/Select/dropdown';
import Moment from 'moment'; 

// ==========================================
//           ESTILOS DEL MODAL
// ==========================================
const modalStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    content: {
        backgroundColor: '#fff',
        width: '90%',
        maxWidth: '1000px',
        height: '85%',
        maxHeight: '600px',
        borderRadius: '4px',
        padding: '0', 
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
    },
    header: {
        padding: '20px',
        borderBottom: '1px solid #eee',
        backgroundColor: '#f8f9fa'
    },
    body: {
        flex: 1,
        overflowY: 'auto',
        padding: '20px'
    },
    footer: {
        padding: '15px 20px',
        borderTop: '1px solid #eee',
        textAlign: 'right',
        backgroundColor: '#f9f9f9'
    },
    closeBtn: {
        float: 'right',
        cursor: 'pointer',
        fontWeight: 'bold',
        fontSize: '20px',
        color: '#999'
    }
};

export default class AddEmailing extends Component {

    constructor(props) {
        super(props);

        this.state = {
            listaCategoriasRecurso: [], 
            categoriaLongitud: 0,
            
            resource: {
                Emai_Asunto: "",
                Emai_Sector: 0, // Inicia en 0
                cxfa_VideoYoutube: "",
                cxfa_Orden: this.props.location.state !== undefined ? this.props.location.state.totalRegistros + 1 : "",
                cxfa_Activo: true,
                filtroCategoria: 0 // Para el filtro del modal
            },
            
            Emai_Anio: 0,
            Emai_Mes: 0,
            Emai_Estado: 0,

            // Validaciones visuales
            Validacion: {
                Emai_Asunto: { Error: false },
                cxfa_VideoYoutube: { Error: false },
                cxfa_Orden: { Error: false },
                Emai_Estado: { Error: false }
            },
            
            // Control de UI
            hasError: false,
            hasErrorProceso: false,
            added: false,
            security: cookie.load('user'),
            roles: [],
            agrupador: "",
            menuGeneral: [],

            // --- ESTADOS POPUP MODAL ---
            modalShow: false,
            modalRecursosData: [],
            modalLoading: false,
            sBuscarRecurso: "",       
            tempSelectedRecursos: [], 
            addedRecursos: [], // Grid Final de recursos seleccionados
            
            // Filtros internos del modal
            filtroYYYY: 0,
            filtroMM: 0
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.openModalRecursos = this.openModalRecursos.bind(this);
        this.closeModalRecursos = this.closeModalRecursos.bind(this);
        this.searchResource = this.searchResource.bind(this);
        this.handleCheckRecurso = this.handleCheckRecurso.bind(this);
        this.addSelectedRecursosToForm = this.addSelectedRecursosToForm.bind(this);
        this.removeRecursoFromForm = this.removeRecursoFromForm.bind(this);
    }

    componentDidMount() {
        if ($('#containerPanel').is("*")) {
            $('#containerPanel').hide();
        }

        let locationState = this.props.location.state;
        let pathNameList = "/categorias-exporta-facil"; 

        var roles = getRoles(this.state.security);
        var rol = roles.length > 0 ? roles[0].nRolCodigo : "";

        axios.get(`${API_URL}CategoryUX/15`)
        .then(response => {
            if(response.data && response.data.result) {
                this.setState({ listaCategoriasRecurso: response.data.result });
            }
        })
        .catch(error => {
            console.error("Error cargando categorías de recursos:", error);
        });

        validateAccesoGeneral(locationState, pathNameList, rol);
    }

    // devAgile = () => {
    //     const mockRecursos = [
    //         { nRecursoCodigo: 13231, sTitulo: "Recurso Simulado (ID: 13231)", sDescripcionTipoRecurso: "Agro", sEnlaceDocumento: "http://google.com" },
    //         { nRecursoCodigo: 13185, sTitulo: "Recurso Simulado (ID: 13185)", sDescripcionTipoRecurso: "Pesca", sEnlaceDocumento: "" },
    //         { nRecursoCodigo: 13146, sTitulo: "Recurso Simulado (ID: 13146)", sDescripcionTipoRecurso: "Manufactura", sEnlaceDocumento: "" }
    //     ];

    //     const randomSubject = "TEST AUTOMÁTICO - " + new Date().toLocaleString();
    //     const currentYear = new Date().getFullYear();
    //     const currentMonth = new Date().getMonth() + 1;

    //     this.setState({
    //         resource: {
    //             ...this.state.resource,
    //             Emai_Asunto: randomSubject,
    //             Emai_Sector: 41, // Forzamos Sector 1 (Agro)
    //         },
    //         Emai_Anio: currentYear,
    //         Emai_Mes: currentMonth,
    //         Emai_Estado: 2, // Estado 2: Por validar
            
    //         // Insertamos los recursos directamente
    //         addedRecursos: mockRecursos, 
    //         categoriaLongitud: randomSubject.length,
            
    //         // Limpieza de errores visuales
    //         Validacion: {
    //             Emai_Asunto: { Error: false },
    //             cxfa_VideoYoutube: { Error: false },
    //             cxfa_Orden: { Error: false },
    //             Emai_Estado: { Error: false }
    //         }
    //     }, () => {
    //         // Callback post-update
    //         toast.success("Formulario rellenado por DevAgile");
    //         console.log(" State actualizado correctamente:", this.state);
    //     });
    // }

    // =========================================================
    //  MANEJO DE INPUTS  
    // =========================================================
   
    handleInputChange(event) {
        const target = event.target;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        // componentes que devuelven objetos {value, label}
        if (value && typeof value === 'object' && value.value !== undefined) {
            value = value.value;
        }

        if (name === "Emai_Sector") {
            if (this.state.addedRecursos.length > 0) {
                if (!window.confirm("Si cambia el sector, se eliminarán los recursos seleccionados. ¿Seguro de continuar?")) {
                    return;  
                } else {
                    this.setState({ addedRecursos: [] });
                }
            }
        }

        let copyResource = this.state.resource;
        copyResource[name] = value;

        let longitudCategoria = this.state.categoriaLongitud;
        let validaciones = this.state.Validacion;
        
        // Reset validación visual
        if (!validaciones[name]) validaciones[name] = { Error: false };
        validaciones[name].Error = false;

        if (name === 'Emai_Asunto') { longitudCategoria = value.length; }

        this.setState({
            resource: copyResource,
            categoriaLongitud: longitudCategoria,
            Validacion: validaciones
        });
    }

    // =========================================================
    //  LÓGICA DEL MODAL (Apertura, Búsqueda, Selección)
    // =========================================================

    openModalRecursos(e) {
        if(e) e.preventDefault();

        // --- VALIDACIÓN PREVIA: Sector Obligatorio ---
        const sector = this.state.resource.Emai_Sector;
        if (!sector || sector == 0 || sector == "0") {
            toast.warning("Debe seleccionar un SECTOR antes de agregar recursos.");
            return;
        }

        this.setState({
            modalShow: true,
            sBuscarRecurso: "",
            tempSelectedRecursos: [],
            modalRecursosData: []
        });
    }

    closeModalRecursos() {
        this.setState({ modalShow: false });
    }

    searchResource(e) { 
        if (e) e.preventDefault();
        
        this.setState({ modalLoading: true });

        const page = '1';
        let search = this.state.sBuscarRecurso;
        const usuario = this.state.security;
        const codUsuario = usuario.nUsuCodigo || 0; 

        if (search === "" || search === null) { search = "ALL"; }

        const anio = this.state.filtroYYYY || 0;
        const mes = this.state.filtroMM || 0;
        const nTipo = this.state.resource.filtroCategoria || 0;
        
        const sector = this.state.resource.Emai_Sector || 0;
        const url = `${API_URL}EmailingUX/GetRecursos/${page}/${codUsuario}/${sector}/${nTipo}/${anio}/${mes}/${search}`;

        axios.get(url).then(response => response.data)
        .then((data) => {
            if (!data.result || data.result.length === 0) {
                // toast.warn("No se encontraron resultados");
            }
            this.setState({
                modalRecursosData: data.result || [],
                modalLoading: false
            });
        }).catch(error => {
            console.error(error);
            this.setState({ modalLoading: false });
            toast.error('Error al buscar recursos en el servidor.');
        });
    }

    handleCheckRecurso(recurso) {
        let selected = [...this.state.tempSelectedRecursos];
        const exists = selected.find(r => r.nRecursoCodigo === recurso.nRecursoCodigo);

        if (exists) {
            selected = selected.filter(r => r.nRecursoCodigo !== recurso.nRecursoCodigo);
        } else {
            selected.push(recurso);
        }
        this.setState({ tempSelectedRecursos: selected });
    }

    addSelectedRecursosToForm() {
        if(this.state.tempSelectedRecursos.length === 0){
            toast.warning("Seleccione al menos un recurso de la lista.");
            return;
        }

        let currentAdded = [...this.state.addedRecursos];
        const newSelection = this.state.tempSelectedRecursos;

        // Fusión sin duplicados
        newSelection.forEach(newItem => {
            if (!currentAdded.find(existing => existing.nRecursoCodigo === newItem.nRecursoCodigo)) {
                currentAdded.push(newItem);
            }
        });

        this.setState({
            addedRecursos: currentAdded,
            modalShow: false
        });
        toast.success("Recursos agregados correctamente.");
    }

    removeRecursoFromForm(idRecurso) {
        if(window.confirm("¿Está seguro de quitar este recurso de la lista?")){
            let currentAdded = this.state.addedRecursos.filter(r => r.nRecursoCodigo !== idRecurso);
            this.setState({ addedRecursos: currentAdded });
        }
    }

    handleClickCancel(e) {
        const { history: { push } } = this.props;
        push('/Emailing'); 
    }

    // =========================================================
    //  GUARDAR (POST) 
    // =========================================================
    callButtonGuardar = (event) => {
        event.preventDefault(); 

        let newState = this.state;
        let hasError = false;
        let validaciones = { ...newState.Validacion };

        if (!newState.resource.Emai_Asunto) { validaciones.Emai_Asunto = { Error: true }; hasError = true; }
        if (!newState.resource.Emai_Sector || newState.resource.Emai_Sector == 0) { toast.warning("Seleccione un Sector"); hasError = true; }
        if (!newState.Emai_Anio || newState.Emai_Anio == 0) { toast.warning("Seleccione un Año"); hasError = true; }
        if (!newState.Emai_Mes || newState.Emai_Mes == 0) { toast.warning("Seleccione un Mes"); hasError = true; }
        if (!newState.Emai_Estado || newState.Emai_Estado == 0) { toast.warning("Seleccione un Estado"); hasError = true; }

        const estado = parseInt(newState.Emai_Estado);
        if (estado === 2 || estado === 3) {
            if (newState.addedRecursos.length === 0) {
                toast.error("Para los estados 'Por Validar' o 'Validado' es obligatorio agregar recursos.");
                hasError = true;
            }
        }

        if (hasError) {
            this.setState({ Validacion: validaciones, hasError: true });
            return;
        }

        const url = `${API_URL}EmailingUX`; 
        const payload = {
            Emai_Asunto: newState.resource.Emai_Asunto,
            Emai_Sector: parseInt(newState.resource.Emai_Sector),
            Emai_Mes: parseInt(newState.Emai_Mes),
            Emai_Anio: parseInt(newState.Emai_Anio),
            Emai_Usuario: newState.security.sUsuNombre || "Admin", 
            Emai_Estado: estado,
            Emai_UsuarioCreacion: newState.security.nUsuCodigo,
            sRecursos: (newState.addedRecursos || []).map(r => r.nRecursoCodigo).join(',')
        };

        const formData = JSON.stringify(payload);
        console.log("Datos enviados (Payload):", payload);

        axios.post(
            url,
            JSON.stringify(formData),
            {
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'Accept': 'application/json'
                }
            }
        ).then(
            (data) => {
                console.log("Respuesta del Servidor:", data);
                
                if (data.data.isSucess) {
                    this.setState({ added: true });
                    toast.success("Emailing registrado exitosamente.");
                    
                    // Redirección
                    setTimeout(() => {
                        this.setState({ added: false });
                        this.props.history.push('/Emailing'); 
                    }, 1500);

                } else {
                    console.warn("Error Controlado (isSucess=false):", data.data.message);
                    toast.error(data.data.message || "Error al registrar el Emailing.");
                    this.setState({ hasErrorProceso: true });
                }
            }
        ).catch((error) => {
            if (error.response) {
                console.error("Status:", error.response.status);
                console.error("Data:", error.response.data);
                toast.error(`Error Servidor (${error.response.status}): Ver consola.`);
            } else if (error.request) {
                console.error("No hubo respuesta:", error.request);
                toast.error("Error: El servidor no responde.");
            } else {
                console.error("Error Config:", error.message);
            }
            console.groupEnd();
        });
    }

    // =========================================================
    //  RENDER MODAL
    // =========================================================
    renderModalContent() {
        if (!this.state.modalShow) return null;

        return (
            <div style={modalStyles.overlay}>
                <div style={modalStyles.content}>
                    
                    {/* Header Modal */}
                    <div style={modalStyles.header}>
                        <span style={modalStyles.closeBtn} onClick={this.closeModalRecursos}>×</span>
                        <h3 style={{margin: 0, color: '#666'}}>Buscador de recursos </h3>
                        
                        <div className="row mt-3">
                            <div className="col-md-3">
                                <label>Recurso</label>
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    placeholder="Título del recurso"
                                    value={this.state.sBuscarRecurso}
                                    onChange={(e) => this.setState({sBuscarRecurso: e.target.value})}
                                />
                            </div>
                            <div className="col-md-3">
                                <label>Categoría</label>
                                <select 
                                        className="form-control"
                                        name="filtroCategoria"
                                        value={this.state.resource.filtroCategoria || 0} 
                                        onChange={this.handleInputChange}
                                        >
                                    <option value="0">-- Todas --</option>
                                    {this.state.listaCategoriasRecurso.map((cat, index) => (
                                        <option key={index} value={cat.crec_Id}>{cat.crec_Nombre}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-md-4">
                                <label>Fecha publicación</label>
                                <div className="d-flex" style={{ display: 'flex' }}>
                                    <select 
                                        name="filtroYYYY"
                                        className="form-control form-control-sm w-50 mr-2"  
                                        style={{ marginRight: '5px' }}  
                                        value={this.state.filtroYYYY}
                                        onChange={(e) => this.setState({ filtroYYYY: e.target.value })}
                                    >
                                        <option value="0">Año</option>
                                        {[...Array(6)].map((_, i) => {
                                            const currentYear = new Date().getFullYear();
                                            const year = currentYear - 1 + i;
                                            return <option key={year} value={year}>{year}</option>;
                                        })}
                                    </select>
                                    <select 
                                        name="filtroMM"
                                        className="form-control form-control-sm w-50"
                                        value={this.state.filtroMM}
                                        onChange={(e) => this.setState({ filtroMM: e.target.value })}
                                    >
                                        <option value="0">Mes</option>
                                        {[...Array(12).keys()].map((m) => (
                                            <option key={m + 1} value={m + 1}>
                                                {new Date(0, m).toLocaleString('es', { month: 'long' })}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="col-md-2 d-flex align-items-end">
                                <button className="btn btn-primary btn-block" onClick={this.searchResource}>
                                    <i className="fa fa-search"></i> BUSCAR
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Body Modal (Tabla) */}
                    <div style={modalStyles.body}>
                        {this.state.modalLoading ? (
                            <div className="text-center p-4">
                                <i className="fas fa-spinner fa-spin fa-2x"></i> Cargando...
                            </div>
                        ) : (
                            <table className="table table-bordered table-striped">
                                <thead style={{backgroundColor: '#4a90e2', color: 'white'}}>
                                    <tr>
                                        <th>Título del recurso</th>
                                        <th>Categoría</th>
                                        <th>Fecha publicación</th>
                                        <th style={{width: '50px', textAlign: 'center'}}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.modalRecursosData.length > 0 ? (
                                        this.state.modalRecursosData.map((item, idx) => {
                                            const isChecked = this.state.tempSelectedRecursos.some(r => r.nRecursoCodigo === item.nRecursoCodigo);
                                            return (
                                                <tr key={idx}>
                                                    <td>{item.sTitulo}</td>
                                                    <td>{item.sDescripcionTipoRecurso}</td>
                                                    <td>{Moment(item.dFechaPublicacion).format('YYYY-MM-DD')}</td>
                                                    <td className="text-center">
                                                        <input 
                                                            type="checkbox" 
                                                            checked={isChecked} 
                                                            onChange={() => this.handleCheckRecurso(item)}
                                                            style={{
                                                                transform: 'scale(1.5)', 
                                                                cursor: 'pointer',
                                                                WebkitAppearance: 'checkbox',
                                                                MozAppearance: 'checkbox',
                                                                appearance: 'checkbox',
                                                                display: 'inline-block' 
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="4" className="text-center">No hay resultados para mostrar</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        )}
                    </div>

                    {/* Footer Modal */}
                    <div style={modalStyles.footer}>
                        <button 
                            className="btn btn-danger" 
                            style={{backgroundColor: '#c0392b', fontWeight: 'bold'}}
                            onClick={this.addSelectedRecursosToForm}
                        >
                            Añadir recurso(s)
                        </button>
                    </div>

                </div>
            </div>
        );
    }

    // =========================================================
    //  RENDER PRINCIPAL
    // =========================================================
    render() {
        return (
            <div className="">
                {this.renderModalContent()}

                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt="" />
                        <a href="/"> / Panel de Configuración General </a>
                        <Link to="/administradores"> / Administradores </Link>
                        <span> / Agregar Emailing</span>
                        
                        {/* <button 
                            onClick={this.devAgile} 
                            className="btn btn-warning btn-sm float-right" 
                            style={{marginLeft: '20px', fontWeight: 'bold', border: '2px solid #333', boxShadow: '2px 2px 5px rgba(0,0,0,0.2)'}}
                        > DEV AGILE
                        </button> */}
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Agregar Emailing
                </div>

                {
                    this.state.hasErrorProceso ?
                        <div className="relative">
                            <div className="textAlertaError">
                                <div>Error, no se pudo realizar el registro.</div>
                            </div>
                        </div> : null
                }

                {
                    this.state.added ?
                        <div className="relative">
                            <div className="textAlertaOK">
                                <div>Se realizó el registro correctamente.</div>
                            </div>
                        </div> : null
                }

                <div className="div_Modulos_Noticias">
                    
                    {/* CAMPO: ASUNTO */}
                    <div className="txtFile x-1">
                        <input 
                            type="text" 
                            placeholder="Asunto" 
                            id='Emai_Asunto' 
                            name='Emai_Asunto' 
                            value={this.state.resource.Emai_Asunto} 
                            maxLength={1000} 
                            className={this.state.Validacion.Emai_Asunto.Error ? "error" : ""}
                            onChange={this.handleInputChange} 
                        />
                        <span data-length={1000}>{this.state.categoriaLongitud}/1000</span>
                    </div>
                    
                    {/* CAMPO: AÑO */}
                    <div className="x-2 relative anio">
                        <select 
                            name="Emai_Anio"
                            className=""
                            value={this.state.Emai_Anio}
                            onChange={(e) => this.setState({ Emai_Anio: e.target.value })}
                        >
                            <option value="0">Año</option>
                            {[...Array(3)].map((_, i) => {
                                const currentYear = new Date().getFullYear();
                                const year = currentYear + i; // Años futuros también
                                return (
                                    <option key={year} value={year}>
                                        {year}
                                    </option>
                                );
                            })}
                        </select>
                    </div>

                    {/* CAMPO: MES */}
                    <div className="txtFile x-2 mes">
                        <select
                            name="Emai_Mes"
                            className=""
                            value={this.state.Emai_Mes}
                            onChange={(e) => this.setState({ Emai_Mes: e.target.value })}
                        >
                            <option value="0">Mes</option>
                            {[...Array(12).keys()].map((m) => (
                                <option key={m + 1} value={m + 1}>
                                    {new Date(0, m).toLocaleString('es', { month: 'long' })}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* CAMPO: SECTOR */}
                    <div className="txtFile x-1">
                        <DropDownList
                            key={this.state.resource.Emai_Sector} 
                            name="Emai_Sector" 
                            id="Emai_Sector"
                            componente={"Sector"}
                            valor={this.state.resource.Emai_Sector}
                            onChange={this.handleInputChange}
                        />
                    </div>

                    {/* SECCIÓN RECURSOS */}
                    <div className="txtFile x-1" style={{border: '1px dashed #ccc', padding: '15px', borderRadius: '5px', backgroundColor: '#fdfdfd'}}>
                        <div className="d-flex align-items-end justify-content-end form-group">
                            <button 
                                type="button" 
                                onClick={this.openModalRecursos} 
                                className="btn btn-sm btn-primary mr-1"
                                style={{fontSize: '14px', fontWeight: 'bold'}}
                            >
                                Agregar recurso...
                            </button>
                        </div>

                        {/* Tabla de seleccionados en el formulario principal */}
                        {this.state.addedRecursos.length > 0 && (
                            <div className="mt-2">
                                <label><strong>Recursos seleccionados:</strong></label>
                                <table className="table table-sm table-bordered" style={{background: 'white'}}>
                                    <thead>
                                        <tr style={{background: '#eee'}}>
                                            <th>Título</th>
                                            <th>Tipo</th>
                                            <th>Enlace</th>
                                            <th style={{width: '40px'}}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.addedRecursos.map((rec, i) => (
                                            <tr key={i}>
                                                <td>{rec.sTitulo}</td>
                                                <td>{rec.sDescripcionTipoRecurso}</td>
                                                <td>
                                                    {rec.sEnlaceDocumento ? (
                                                            <a 
                                                                href={rec.sEnlaceDocumento} 
                                                                target="_blank" 
                                                                rel="noopener noreferrer"
                                                                style={{ color: '#007bff', textDecoration: 'underline', cursor: 'pointer' }}
                                                            >
                                                                Ver
                                                            </a>
                                                        ) : (
                                                            <span>-</span>
                                                        )}
                                                </td>                                                
                                                <td className="text-center">
                                                       <i 
                                                        className="fa fa-trash" 
                                                        style={{
                                                            color: 'red', 
                                                            cursor: 'pointer', 
                                                            fontSize: '18px' ,
                                                            fontFamily: 'FontAwesome'
                                                        }} 
                                                        title="Quitar"
                                                        onClick={() => this.removeRecursoFromForm(rec.nRecursoCodigo)}
                                                    ></i>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                    
                    {/* CAMPO: ESTADO */}
                    <div className="txtFile x-1">
                        <div className="form-group">
                            <label htmlFor="Emai_Estado" className='h6'>
                                <strong>
                                    Estado
                                    <span className='font-weight-bold text-danger ml-2'>*</span>
                                </strong>
                            </label>
                            <div className="">
                                <select 
                                    name="Emai_Estado"
                                    className="form-control form-control-sm w-50"
                                    value={this.state.Emai_Estado}
                                    onChange={(e) => this.setState({ Emai_Estado: e.target.value })}
                                >
                                        <option value="1" >Borrador</option>
                                        <option value="2" >Por validar</option>
                                        {/* <option value="3" >Validado</option> */}
                                </select>
                            </div>
                        </div>
                    </div>

                    {/* BOTONES ACCIÓN */}
                    <div className="divContenedorBtn_Noticias">
                        <a href="#" className="btnActivo" onClick={(event) => this.callButtonGuardar(event)}>GUARDAR </a>
                        <a href="#" onClick={(event) => this.handleClickCancel(event)}>VOLVER</a>
                    </div>
                </div>
                <br />
                <br />

            </div>
        )
    }
}